module.exports = __webpack_public_path__ + "static/media/back-white.6859113a.svg";